// Modules
import React from "react";

const TableIcon = (props) => {
  return (
    <svg
      height="1em"
      viewBox="0 0 512 512"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M503.76,158.06l-8-32A8,8,0,0,0,488,120H24a8,8,0,0,0-7.76,6.06l-8,32A8,8,0,0,0,16,168H40V384a8,8,0,0,0,8,8H72a8,8,0,0,0,8-8V272H432V384a8,8,0,0,0,8,8h24a8,8,0,0,0,8-8V168h24a8,8,0,0,0,7.76-9.94ZM64,376H56V168h8ZM432,256H80V168H432Zm24,120h-8V168h8ZM26.25,152l4-16h451.5l4,16Z"/>
    </svg>
  );
};

export default TableIcon;
